import { Fetcher } from '@this/src/util';

type ArrangementConfirmationResponse = {
  success: boolean;
  message_id?: number;
  error?: string;
};

export type ArrangementConfirmationResult = {
  success: boolean;
  messageId?: number;
  error?: string;
};

const convertResponse = (response: ArrangementConfirmationResponse): ArrangementConfirmationResult => ({
  success: response.success,
  messageId: response.message_id,
  error: response.error
});

export const createArrangementConfirmation = async (tripId: string): Promise<ArrangementConfirmationResult> => {
  const response = await Fetcher.post<ArrangementConfirmationResponse>(
    `/trips/${tripId}/ai_arrangement_confirmation`,
    {}
  );
  return convertResponse(response);
};
